export const is20x = (req) => {
    return req.status.toString().startsWith("2");
}